import BagQtySync from "../../assets/js/hooks/bag_qty_sync";
import CarouselSwipe from "../../assets/js/hooks/carousel_swipe";
import ClearInput from "../../assets/js/hooks/clear_input";
import {
  Clock,
  Countdown,
  ItemTimer,
  Timer,
} from "../../assets/js/hooks/clocks";
import Copy from "../../assets/js/hooks/copy";
import Flash from "../../assets/js/hooks/flash";
import GoogleMap from "../../assets/js/hooks/google_map";
import PlaceAutoComplete from "../../assets/js/hooks/google_place_autocomplete";
import HidePressToScroll from "../../assets/js/hooks/hide_press_to_scroll";
import InfiniteScroll from "../../assets/js/hooks/infinite_scroll";
import InternationalPhoneNumber from "../../assets/js/hooks/international_phone_number";
import LottieAnimation from "../../assets/js/hooks/lottie";
import Modal from "../../assets/js/hooks/modal";
import RecaptchaToken from "../../assets/js/hooks/recaptcha_token";
import RestaurantScroll from "../../assets/js/hooks/restaurant_scroll";
import ScrollTo from "../../assets/js/hooks/scroll_to";
import SelectOnFocus from "../../assets/js/hooks/select_on_focus";
import StoreMenuScroll from "../../assets/js/hooks/store_menu_scroll";
import { StripePaymentForm } from "../../assets/js/hooks/stripe_elements";

const Hooks = {
  BagQtySync,
  CarouselSwipe,
  ClearInput,
  Clock,
  Copy,
  Countdown,
  Flash,
  GoogleMap,
  HidePressToScroll,
  InfiniteScroll,
  InternationalPhoneNumber,
  ItemTimer,
  LottieAnimation,
  Modal,
  PlaceAutoComplete,
  RecaptchaToken,
  RestaurantScroll,
  ScrollTo,
  SelectOnFocus,
  StoreMenuScroll,
  StripePaymentForm,
  Timer,
};

export default Hooks;
